import { useTranslation } from "react-i18next";
import Field from "../../Field/Field";
import HTMLParser from "../../HTMLParser/HTMLParser";
import { getErrorMessage, Mode, QuestionField } from "../Form";
import { ShortText } from "../ShortText/ShortText";
import { LongText } from "../LongText/LongText";
import styles from "./TextFieldComponent.module.scss";

type Props<T extends ShortText | LongText> = {
  element: T,
  mode: Mode,
  onElementChange: (element: T) => void,
  multiline?: boolean,
}

export const TextFieldComponent = <T extends ShortText | LongText>({ element, mode, onElementChange, multiline }: Props<T>) => {
  const [t] = useTranslation('shared', { keyPrefix: 'form' });
  const { question, answer, required, answerErrorMessage, questionErrorMessage } = element;

  const translatedAnswerErrorMessage = getErrorMessage(t, answerErrorMessage);
  const translatedQuestionErrorMessage = getErrorMessage(t, questionErrorMessage);

  if (mode === Mode.FORM) {
    return <Field multiline={multiline} required={required} label={<HTMLParser data={question} />} value={answer} errorMessage={translatedAnswerErrorMessage} onChange={(value) => {
      element.answer = value;
      onElementChange(element);
    }} />
  } else if (mode === Mode.READ_ONLY) {
    if (multiline) {
      return (
        <div className={styles.readOnlyContainer}>
          <span className={styles.label}><HTMLParser data={question} />{required && <span style={{ color: 'var(--orange-500)', marginLeft: '3px' }}>*</span>}</span>
          <div className={styles.content}><HTMLParser data={answer} /></div>
        </div>
      )
    }
    return <Field required={required} label={<HTMLParser data={question} />} value={answer} disabled />
  } else if (mode === Mode.EDIT) {
    return (
      <QuestionField
        value={question}
        onChange={(value) => {
          element.question = value;
          onElementChange(element);
        }}
        errorMessage={translatedQuestionErrorMessage}
      />
    )
  }
}